<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <h2 class="page-title on-white-bg">
        {{ form.name ? $t('companyManagement.editCompany') : $t('companyManagement.addCompany') }}
      </h2>
      <form @submit.prevent="handleSave">
        <div class="form-group">
          <label for="name">{{ $t('companyManagement.company') }}</label>
          <input id="name" v-model="form.name" type="text" required />
        </div>
        <div class="form-group">
          <label for="subdomain">{{ $t('companyManagement.subdomain') }}</label>
          <input id="subdomain" v-model="form.subdomain" type="text" />
        </div>
        <div class="form-group">
          <label for="org_number">{{ $t('companyManagement.org_number') }}</label>
          <input id="org_number" v-model="form.org_number" type="text" />
        </div>
        <div class="form-group">
          <label for="address">{{ $t('companyManagement.address') }}</label>
          <input id="address" v-model="form.address" type="text" />
        </div>
        <div class="form-group">
          <label for="billing_status">{{ $t('companyManagement.billing_status.status') }}</label>
          <select id="billing_status" v-model="form.billing_status">
            <option value="trial">{{ $t('companyManagement.billing_status.trial') }}</option>
            <option value="active">{{ $t('companyManagement.billing_status.active') }}</option>
            <option value="suspended">{{ $t('companyManagement.billing_status.suspended') }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="is_active">{{ $t('companyManagement.is_active') }}</label>
          <input id="is_active" v-model="form.is_active" type="checkbox" />
        </div>
        <div class="form-group">
          <label for="active_user_count">{{ $t('companyManagement.active_user_count') }}</label>
          <input id="active_user_count" v-model="form.active_user_count" type="number" min="0" />
        </div>
        <div class="form-group">
          <label for="price_per_user">{{ $t('companyManagement.price_per_user') }}</label>
          <input id="price_per_user" v-model="form.price_per_user" type="number" step="0.01" min="0" />
        </div>
        <div class="form-group">
          <label for="next_billing_date">{{ $t('companyManagement.next_billing_date') }}</label>
          <input id="next_billing_date" v-model="form.next_billing_date" type="date" />
        </div>
        <div class="form-group">
          <label for="created_at">{{ $t('companyManagement.created_at') }}</label>
          <input id="created_at" v-model="form.created_at" type="text" disabled />
        </div>
        <div class="form-group">
          <label for="updated_at">{{ $t('companyManagement.updated_at') }}</label>
          <input id="updated_at" v-model="form.updated_at" type="text" disabled />
        </div>
        <div class="modal-actions">
          <button class="cancel-btn" type="button" @click="$emit('close')">{{ $t('common.cancel') }}</button>
          <button class="accept-btn" type="submit">{{ $t('common.save') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch } from 'vue'
const props = defineProps({
  company: { type: Object, required: true }
})
const emit = defineEmits(['close', 'save'])
const form = reactive({ ...props.company })
watch(() => props.company, (newVal) => {
  Object.assign(form, newVal)
})
function handleSave() {
  emit('save', { ...form })
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  min-width: 350px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
}
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
.form-group input {
  width: 100%;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.form-group select {
  width: 100%;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 18px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.on-white-bg {
  color: #59008d;
}

.modal-actions button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}
.cancel-btn {
  background: #f5f5f5;
  color: #333;
}

.cancel-btn:hover {
  background: #e0e0e0;
}

.accept-btn {
  background: #28a745;
  color: white;
}

.accept-btn:hover {
  background: #218838;
}
</style>
